const planModules = [
  { key: 'onlineBooking', title: 'نوبت‌دهی', names: ['نوبت دهی'] },
  { key: 'virtualVisit', title: 'ویزیت مجازی', names: [] },
  { key: 'healthRecord', title: 'سوابق الکترونیک سلامت', names: ['پرونده سلامت'] },
  { key: 'clinicCampaign', title: 'کمپین فروش', names: [] },
  { key: 'leadGen', title: 'جمع‌آوری مشتری', names: ['جمع اوری مشتری'] },
  { key: 'support', title: 'پشتیبانی اختصاصی', names: [] },
] as const

export interface PlanCatalogModule {
  key: string
  name?: {
    fa?: string
    en?: string
  }
}

function normalizeModuleName(name: string | undefined): string {
  return (name ?? '')
    .replace(/[‌\s]/g, '')
    .replace(/ي/g, 'ی')
    .replace(/ك/g, 'ک')
    .replace(/آ/g, 'ا')
}

function findPlanModule(module: PlanCatalogModule) {
  const normalizedName = normalizeModuleName(module.name?.fa)
  return planModules.find(item =>
    item.key === module.key
    || [item.title, ...item.names].some(name => normalizeModuleName(name) === normalizedName),
  )
}

export function isPlanCatalogModule(module: PlanCatalogModule): boolean {
  return Boolean(findPlanModule(module))
}

export function getPlanCatalogModuleTitle(module: PlanCatalogModule): string {
  return findPlanModule(module)?.title || module.name?.fa || module.name?.en || module.key
}
